import {
  LEGALBRIDGE_LOADING,
  GET_LEGALBRIDGE,
  GET_LEGALBRIDGE_SUCCESS,
  GET_LEGALBRIDGE_FAIL,
  ADD_LEGALBRIDGE_SUCCESS,
  ADD_LEGALBRIDGE_FAIL,
  DELETE_LEGALBRIDGE_SUCCESS,
  DELETE_LEGALBRIDGE_FAIL,
  UPDATE_LEGALBRIDGE_SUCCESS,
  UPDATE_LEGALBRIDGE_FAIL,
  LEGALBRIDGE_RESET
} from "./actionType";

const INIT_STATE = {
  legalBridges: [],
  error: {},
};

const LegalBridge = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEGALBRIDGE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LEGALBRIDGE:
          return {
            ...state,
            legalBridges: action.payload.data,
            isLegalBridgeCreated: false,
            isLegalBridgeSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LEGALBRIDGE_FAIL:
      switch (action.payload.actionType) {
        case GET_LEGALBRIDGE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLegalBridgeCreated: false,
            isLegalBridgeSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LEGALBRIDGE: {
      return {
        ...state,
        isLegalBridgeCreated: false,
        loading: true,
      };
    }

    case LEGALBRIDGE_LOADING: {
      return {
        ...state,
        isLegalBridgeCreated: false,
        loading: true,
      };
    }

    case ADD_LEGALBRIDGE_SUCCESS:
      return {
        ...state,
        isLegalBridgeCreated: true,
        loading: false,
        legalBridges: [action.payload.data, ...state.legalBridges],
      };

    case ADD_LEGALBRIDGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LEGALBRIDGE_SUCCESS:
      return {
        ...state,
        loading: false,
        legalBridges: state.legalBridges.filter(
          legalBridge => legalBridge.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LEGALBRIDGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LEGALBRIDGE_SUCCESS:
      return {
        ...state,
        loading: false,
        legalBridges: state.legalBridges.map(legalBridge =>
          legalBridge.id.toString() === action.payload.data.id.toString() ? { ...legalBridge, ...action.payload.data } : legalBridge
        ),
      };

    case UPDATE_LEGALBRIDGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LEGALBRIDGE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default LegalBridge;